import { ApiClient } from './client.js'
import { TRACKS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (trackId) {
    return client.get(`${TRACKS}${trackId}/`)
  },

  list () {
    return client.get(`${TRACKS}`)
  },

  listAll () {
    return client.getAll(`${TRACKS}`)
  },

  similar (trackId) {
    return client.get(`${TRACKS}${trackId}/similar/`)
  }
}
